// Round 3 (10/17): a lane's new feature reads its switch here until the release lead adds it to lib/flags.ts (only the release
// lead edits that file). A name flags.ts does not have yet counts as on: the shipped behavior, with nothing for QA to toggle.
import { FLAGS, flag, useFlag, type FlagName } from './flags'

const known = (n: string): n is FlagName => Object.hasOwn(FLAGS, n)
export const laneFlag = (n: string): boolean => (known(n) ? flag(n) : true)
/** React version: `known` is fixed for a given build, so the hook is always (or never) called for a name. */
export function useLaneFlag(n: string): boolean {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return known(n) ? useFlag(n) : true
}
